import { render, staticRenderFns } from "./SidebarNavTitle.vue?vue&type=template&id=a4c92d7e&"
import script from "./SidebarNavTitle.vue?vue&type=script&lang=js&"
export * from "./SidebarNavTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarNavTitle.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/SidebarNavTitle.vue
// module id = null
// module chunks = 